import {
  Alert,
  alertTypes,
  alertVariants,
  NewButton,
  NewButtonVariant,
  TooltipTrigger,
} from "@visiblethread/react-components";
import EmptyState from "components/EmptyState";
import { ListIcon } from "lucide-react";
import { bool, func } from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAnalysisLlmEnabled } from "slices/generativeAi/actions";
import { selectIsLlmAvailable } from "slices/generativeAi/selectors";
import { initializeManualEditing } from "slices/proposalOutline/actions/outlineActions";
import {
  selectIsLocked,
  selectLockedBy,
  selectOutlineOwner,
} from "slices/proposalOutline/selectors";

import { GenerateOutlineButton } from "./components/OutlineTableHeader";

const ProposalEmptyState = ({ onSubmitDocuments, isArchived = false }) => {
  const dispatch = useDispatch();
  const owner = useSelector(selectOutlineOwner);
  const isLocked = useSelector(selectIsLocked);
  const lockedBy = useSelector(selectLockedBy);
  const isLlmAvailable = useSelector(selectIsLlmAvailable);

  useEffect(() => {
    dispatch(fetchAnalysisLlmEnabled());

    const onFocus = () => {
      dispatch(fetchAnalysisLlmEnabled());
    };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [dispatch]);

  const onClickManual = async () => {
    if (!owner) {
      return;
    }
    await dispatch(initializeManualEditing(owner.ownerType, owner.ownerId));
  };

  return (
    <>
      {isLocked && (
        <Alert
          variant={alertVariants.warning}
          text={`You can not edit this list as ${lockedBy} is currently editing`}
          type={alertTypes.inline}
          hideCloseButton
        />
      )}
      <EmptyState
        buttons={[
          <NewButton
            data-testid="manual-create-button"
            onClick={onClickManual}
            variant={NewButtonVariant.l2}
            disabled={isLocked || isArchived}
          >
            Manually Create Outline
          </NewButton>,
          <TooltipTrigger
            content={
              !isLlmAvailable
                ? "Ask your system administrator to turn on Generative AI – Tech Alignment & Outlines in the System Admin panel so you can Generate Outline With AI"
                : undefined
            }
          >
            <GenerateOutlineButton
              content="Generate Outline with AI"
              onSubmitDocuments={onSubmitDocuments}
              disabled={isArchived || !isLlmAvailable}
            />
          </TooltipTrigger>,
        ]}
        description="Get started by adding sections manually or generating an outline from your documents"
        icon={<ListIcon size={24} color="#533ffb" />}
        title="Start building your outline"
      />
    </>
  );
};

ProposalEmptyState.propTypes = {
  isArchived: bool,
  onSubmitDocuments: func,
};

export default ProposalEmptyState;
